import { render, staticRenderFns } from "./RatingField.vue?vue&type=template&id=e04d5152"
import script from "./rating-field.ts?vue&type=script&lang=ts&external"
export * from "./rating-field.ts?vue&type=script&lang=ts&external"
import style0 from "./rating-field.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports